import { Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '@bloomcode/error-handling';
import { LoadingSpinner, Toaster } from '@bloomcode/ui';
import { getAuthPortalLoginUrl, getAuthPortalSignupUrl } from './config/env';

// Layouts
import MainLayout from './layouts/MainLayout';

// Pages
import HomePage from './pages/HomePage';
import DashboardPage from './pages/dashboard/DashboardPage';
import NotFoundPage from './pages/NotFoundPage';

// Content Pages
import { 
  ContentListPage, 
  ContentDetailPage, 
  CategoryPage, 
  SearchPage,
  UserPreferencesPage 
} from './pages/content';

/**
 * Redirects to auth portal for login
 */
function AuthPortalRedirect() {
  useEffect(() => {
    const returnUrl = window.location.origin + '/dashboard';
    window.location.href = getAuthPortalLoginUrl(returnUrl);
  }, []);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to login...</p>
      </div>
    </div>
  );
}

/**
 * Redirects to auth portal for signup
 */
function AuthPortalSignupRedirect() {
  useEffect(() => {
    const returnUrl = window.location.origin + '/dashboard';
    window.location.href = getAuthPortalSignupUrl(returnUrl, 'Bloomcode CMS');
  }, []);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to signup...</p>
      </div>
    </div>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner className="h-screen" />}>
        <Routes>
          {/* Public routes */}
          <Route element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="content" element={<ContentListPage />} />
            <Route path="content/:slug" element={<ContentDetailPage />} />
            <Route path="category/:category" element={<CategoryPage />} />
            <Route path="search" element={<SearchPage />} />
          </Route>

          {/* Auth routes - redirect to auth portal */}
          <Route path="/auth/login" element={<AuthPortalRedirect />} />
          <Route path="/auth/register" element={<AuthPortalSignupRedirect />} />
          <Route path="/login" element={<AuthPortalRedirect />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={<MainLayout requireAuth />}>
            <Route index element={<DashboardPage />} />
          </Route>
          
          <Route path="/preferences" element={<MainLayout requireAuth />}>
            <Route index element={<UserPreferencesPage />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <Toaster />
    </ErrorBoundary>
  );
}
